export default __webpack_public_path__ + "static/media/trash-icon.52a49f47.svg";